import React from 'react'
import { Button, Checkbox, Empty, Space, Spin, Tag, Typography } from 'antd'
import { DeleteOutlined, EyeOutlined } from '@ant-design/icons'

const { Text } = Typography

// 两个页面共用的页面清单：负责人端可勾选授权，管理员端可查看权限并删除页面。
export default function VibeRouteList({
    routes = [], loading = false, selectedIds = [], onSelectionChange,
    focusedRouteId, onPreview, onDelete, renderPermissions,
}) {
    return <Spin spinning={loading}>
        <div className="vibe-route-list">
            {!routes.length && <Empty description="尚未同步页面路由" image={Empty.PRESENTED_IMAGE_SIMPLE} />}
            {routes.map(route => {
                const routeId = route.id
                const selected = selectedIds.includes(routeId)
                return <div className={`vibe-route-item${selected ? ' is-selected' : ''}`} key={routeId}>
                    {onSelectionChange ? <Checkbox checked={selected} onChange={event => onSelectionChange(
                        event.target.checked
                            ? [...selectedIds, routeId]
                            : selectedIds.filter(id => id !== routeId),
                    )} /> : null}
                    <div className="vibe-route-copy">
                        <Text strong>{route.routeName || route.routeKey || '未命名页面'}</Text>
                        <Text type="secondary" code>{route.pathPattern || route.path || '/'}</Text>
                        {String(routeId) === String(focusedRouteId) && <Tag color="gold">这次要处理</Tag>}
                        {renderPermissions ? <div>{renderPermissions(route)}</div> : null}
                    </div>
                    <Space size={8}>
                        {onPreview ? <Button type="link" icon={<EyeOutlined />} onClick={() => onPreview(route)}>预览</Button> : null}
                        {onDelete ? <Button type="link" danger icon={<DeleteOutlined />} onClick={() => onDelete(route)}>删除页面</Button> : null}
                    </Space>
                </div>
            })}
        </div>
    </Spin>
}
